import React, { useState } from 'react';
import Popup from 'reactjs-popup';
 
const ConfirmationModalEventValidation = ({ isOpen, onClose, onSave, onCancel }) => {
    const [checkNotif, setCheckNotif] = useState(true);
    const toggleCheckNotif = () => {
        setCheckNotif((prevCheckNotif) => !prevCheckNotif);
      };
 
    const handleSave = () => {
        onSave(checkNotif);  
        setCheckNotif(true); 
    };

    const handleCancel = () => {
        onCancel(checkNotif);  
        setCheckNotif(true); 
    };
 
    return (
        <Popup
            open={isOpen}
            onClose={onClose}
            contentStyle={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '20px',
                border: '1px solid #d9d7d7',
                borderRadius: '5px',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
            }}
            overlayStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                zIndex: 1040,
            }}
        >
            <div className="modal-content" style={{ color: 'darkblue' }}>
                <h5 className='popupTitle'>Please confirm the validation and opening of the event.</h5>
                <div className="form-group">
                  <div className="align-items-center mb-2 d-flex">
                    <input className="form-check-input-custom2 form-check-input" type="checkbox" id="chkCheckNotif" checked={checkNotif} onChange={toggleCheckNotif} />
                    <span className="font-mars-centra" style={{ userSelect: 'none', cursor: 'pointer' }} onClick={toggleCheckNotif} >Send new event notification to family</span>
                  </div>
                </div>
                <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button className="btn btn-cancel" onClick={handleCancel}>CANCEL</button>
                    <button className="btn btn-save" onClick={handleSave}>CONFIRM</button>
                </div>
            </div>
        </Popup>
    );
};
 
export default ConfirmationModalEventValidation;